import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { copy } from "@aasaan-share/ui-contract";

var root = $.from_html(`<a class="secondary-button admission-app-link">Open in AasaanShare app</a>`);
var root_1 = $.from_html(`<span aria-hidden="true" class="button-spinner"></span>`);
var root_2 = $.from_html(`<main class="admission-main" id="main-content"><section aria-labelledby="admission-title" class="admission-state"><header class="admission-header"><img alt="AasaanShare" class="admission-wordmark" height="45" src="/assets/logo-wordmark.svg" width="145"/></header> <div class="admission-hero admission-hero-invitation"><span aria-hidden="true" class="admission-symbol">💌</span> <h1 id="admission-title">A private album is waiting for you.</h1> <p class="admission-detail"> </p></div> <div class="admission-steps" aria-label="What happens next"><h2>What happens next?</h2> <div class="admission-step"><span>1</span> <p><strong>Confirm your email</strong><small>We send a short code to the address chosen for this invitation.</small></p></div> <div class="admission-step"><span>2</span> <p><strong>Choose this device</strong><small>It becomes a trusted way to open albums shared with you.</small></p></div></div> <!> <button class="primary-button" data-action="request-code" type="button"><!> </button></section></main>`);
var root_3 = $.from_html(`<p class="verification-error" role="alert"> </p>`);
var root_4 = $.from_html(`<main class="admission-main" id="main-content"><section aria-labelledby="admission-title" class="admission-state"><header class="admission-header"><img alt="AasaanShare" class="admission-wordmark" height="45" src="/assets/logo-wordmark.svg" width="145"/></header> <div class="verification-intro"><span aria-hidden="true" class="verification-spark">✦</span> <h1 id="admission-title">A quick hello to your inbox.</h1> <p class="admission-detail"> </p></div> <form class="verification-form" data-form="verification"><label for="verification-code">Six-digit code</label> <input autocomplete="one-time-code" id="verification-code" inputmode="numeric" maxlength="6" name="code" required="" type="text"/> <button class="primary-button" type="submit"><!> </button> <!></form> <aside class="resend-panel"><h2>Didn’t get a code?</h2> <p>You can request another one shortly. Each code is short-lived for your security.</p> <button class="secondary-button" data-action="request-code" type="button">Resend code</button></aside></section></main>`);
var root_5 = $.from_html(`<a class="primary-button">Sign in with another account</a>`);
var root_6 = $.from_html(`<button class="primary-button" data-action="retry-connection" type="button"> </button>`);
var root_7 = $.from_html(`<main class="admission-main" id="main-content"><section aria-labelledby="admission-title" class="admission-state"><header class="admission-header"><img alt="AasaanShare" class="admission-wordmark" height="45" src="/assets/logo-wordmark.svg" width="145"/></header> <div><span aria-hidden="true" class="admission-symbol"> </span> <h1 id="admission-title"> </h1> <p class="admission-detail"> </p> <!></div> <aside class="privacy-panel"><h2>Privacy stays in place</h2> <p>This browser only receives access after your invitation and email have been verified.</p></aside></section></main>`);

export default function AdmissionView($$anchor, $$props) {
	$.push($$props, true);

	let verificationSubmitting = $.derived(() => $$props.model.verificationSubmitting === true);
	let admissionState = $.derived(() => $$props.model.admission === "reconnecting" || $$props.model.admission === "connected" ? "connecting" : $$props.model.admission);
	let admissionContent = $.derived(() => copyFor($.get(admissionState), $$props.model.destination));
	let nativeAppUrl = $.derived(nativeInvitationUrl);

	function nativeInvitationUrl() {
		const token = location.hash.match(/^#([A-Za-z0-9_-]{16,128})$/)?.[1];

		return token ? `aasaanshare://invite#${token}` : undefined;
	}

	function copyFor(state, destination) {
		switch (state) {
			case "authorizing":
				return {
					detail: "This will only take a moment.",
					title: copy["viewer.admission.authorizing"]
				};

			case "waiting-for-owner":
				return {
					detail: "This album will open automatically once it has finished preparing.",
					title: copy["viewer.admission.waitingForOwner"]
				};

			case "waiting-for-capacity":
				return {
					detail: "This share will open automatically when it is ready.",
					title: copy["viewer.admission.waitingForCapacity"]
				};

			case "unavailable":
				return {
					detail: destination ?? "Try again, or return to the invitation you received.",
					title: copy["viewer.admission.unavailable"]
				};

			default:
				return {
					detail: "Connecting securely to the sender's device.",
					title: copy["viewer.admission.connecting"]
				};
		}
	}

	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent_2 = ($$anchor) => {
			var main = root_2();
			var section = $.child(main);
			var div = $.sibling($.child(section), 2);
			var p = $.sibling($.child(div), 4);
			var text = $.child(p, true);

			$.reset(p);
			$.reset(div);

			var node_1 = $.sibling(div, 4);

			{
				var consequent = ($$anchor) => {
					var a = root();

					$.template_effect(() => $.set_attribute(a, 'href', $.get(nativeAppUrl)));
					$.append($$anchor, a);
				};

				$.if(node_1, ($$render) => {
					if ($.get(nativeAppUrl)) $$render(consequent);
				});
			}

			var button = $.sibling(node_1, 2);
			var node_2 = $.child(button);

			{
				var consequent_1 = ($$anchor) => {
					var span = root_1();

					$.append($$anchor, span);
				};

				$.if(node_2, ($$render) => {
					if ($.get(verificationSubmitting)) $$render(consequent_1);
				});
			}

			var text_1 = $.sibling(node_2);

			$.reset(button);
			$.reset(section);
			$.reset(main);

			$.template_effect(() => {
				$.set_text(text, $$props.model.destination || $$props.model.announcement || "Open the album privately. You do not need an AasaanShare account.");
				$.set_attribute(button, 'aria-busy', $.get(verificationSubmitting) ? "true" : undefined);
				button.disabled = $.get(verificationSubmitting);

				$.set_text(text_1, ` ${$.get(verificationSubmitting)
					? "Sending verification code..."
					: "Send verification code"}`);
			});

			$.append($$anchor, main);
		};

		var consequent_5 = ($$anchor) => {
			var main_1 = root_4();
			var section_1 = $.child(main_1);
			var div_1 = $.sibling($.child(section_1), 2);
			var p_1 = $.sibling($.child(div_1), 4);
			var text_2 = $.child(p_1, true);

			$.reset(p_1);
			$.reset(div_1);

			var form = $.sibling(div_1, 2);
			var input = $.sibling($.child(form), 2);

			$.set_attribute(input, 'pattern', "[0-9]{6}");

			var button_1 = $.sibling(input, 2);
			var node_3 = $.child(button_1);

			{
				var consequent_3 = ($$anchor) => {
					var span_1 = root_1();

					$.append($$anchor, span_1);
				};

				$.if(node_3, ($$render) => {
					if ($.get(verificationSubmitting)) $$render(consequent_3);
				});
			}

			var text_3 = $.sibling(node_3);

			$.reset(button_1);

			var node_4 = $.sibling(button_1, 2);

			{
				var consequent_4 = ($$anchor) => {
					var p_2 = root_3();
					var text_4 = $.child(p_2, true);

					$.reset(p_2);
					$.template_effect(() => $.set_text(text_4, $$props.model.announcement));
					$.append($$anchor, p_2);
				};

				$.if(node_4, ($$render) => {
					if ($$props.model.announcement) $$render(consequent_4);
				});
			}

			$.reset(form);

			var aside = $.sibling(form, 2);
			var button_2 = $.sibling($.child(aside), 4);

			$.reset(aside);
			$.reset(section_1);
			$.reset(main_1);

			$.template_effect(() => {
				$.set_text(text_2, $$props.model.destination ?? "Enter the six-digit code sent to your email. This keeps the album private to the people invited.");
				$.set_attribute(form, 'aria-busy', $.get(verificationSubmitting) ? "true" : undefined);
				input.disabled = $.get(verificationSubmitting);
				$.set_attribute(button_1, 'aria-busy', $.get(verificationSubmitting) ? "true" : undefined);
				button_1.disabled = $.get(verificationSubmitting);
				$.set_text(text_3, ` ${$.get(verificationSubmitting) ? "Verifying code..." : "Verify and open album"}`);
				button_2.disabled = $.get(verificationSubmitting);
			});

			$.append($$anchor, main_1);
		};

		var alternate_1 = ($$anchor) => {
			var main_2 = root_7();
			var section_2 = $.child(main_2);
			var div_2 = $.sibling($.child(section_2), 2);
			let classes;
			var span_2 = $.child(div_2);
			var text_5 = $.child(span_2, true);

			$.reset(span_2);

			var h1 = $.sibling(span_2, 2);
			var text_6 = $.child(h1, true);

			$.reset(h1);

			var p_3 = $.sibling(h1, 2);
			var text_7 = $.child(p_3, true);

			$.reset(p_3);

			var node_5 = $.sibling(p_3, 2);

			{
				var consequent_7 = ($$anchor) => {
					var fragment_1 = $.comment();
					var node_6 = $.first_child(fragment_1);

					{
						var consequent_6 = ($$anchor) => {
							var a_1 = root_5();

							$.template_effect(() => $.set_attribute(a_1, 'href', $$props.model.accountSignInUrl));
							$.append($$anchor, a_1);
						};

						var alternate = ($$anchor) => {
							var button_3 = root_6();
							var text_8 = $.child(button_3, true);

							$.reset(button_3);
							$.template_effect(() => $.set_text(text_8, copy["action.tryAgain"]));
							$.append($$anchor, button_3);
						};

						$.if(node_6, ($$render) => {
							if ($$props.model.accountSignInUrl) $$render(consequent_6); else $$render(alternate, -1);
						});
					}

					$.append($$anchor, fragment_1);
				};

				$.if(node_5, ($$render) => {
					if ($.get(admissionState) === "unavailable") $$render(consequent_7);
				});
			}

			$.reset(div_2);
			$.next(2);
			$.reset(section_2);
			$.reset(main_2);

			$.template_effect(() => {
				classes = $.set_class(div_2, 1, 'admission-hero', null, classes, {
					'admission-hero-unavailable': $.get(admissionState) === "unavailable"
				});

				$.set_text(text_5, $.get(admissionState) === "unavailable" ? "⌛" : "🔐");
				$.set_text(text_6, $.get(admissionContent).title);
				$.set_text(text_7, $.get(admissionContent).detail);
			});

			$.append($$anchor, main_2);
		};

		$.if(node, ($$render) => {
			if ($$props.model.mode === "invitation") $$render(consequent_2); else if ($$props.model.mode === "verification") $$render(consequent_5, 1); else $$render(alternate_1, -1);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}